module.exports = __webpack_public_path__ + "img/pic2.9bb06444.png";